import { z } from "zod"

// zod probes for `Function` as it builds its first object schema, to compile faster parsers. The
// deployed CSP has no 'unsafe-eval', so that probe is a securitypolicyviolation and a CSP report on
// every page, though zod catches the throw. jitless skips the probe and the compiled parsers.
// main.tsx imports this before anything that imports @ternary/contracts.
z.config({ jitless: true })
